/* eslint-disable */


/**
 * Create styles for `<SpeedDialActionWrapper />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<SpeedDialActionWrapper />` styles
 */
const speedDialActionWrapperStyles = ({ theme }) => ({
  button: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.grey['500'],
  },
  tooltip: {
    minWidth: 'max-content',
  },
  speedDialIcon: {
    paddingTop: theme.spacing(1),
  },
  tooltip: {
    width: `max-content`,
    ...theme.typography.subtitle2,
  }
});

export default speedDialActionWrapperStyles;
